<template>
    <common-modal v-if="isOpen" width="extra-large" @close="emitEvent({ name: 'close' })">
        <common-content-spacer height="medium">
            <common-content-wrapper width="large"></common-content-wrapper>
            <add-patient-form @cancel="emitEvent({ name: 'close' })"></add-patient-form>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    import AddPatientForm from 'components/forms/patient/AddPatientForm'
    export default {
        components: { AddPatientForm },
        props: {
            isOpen: { type: Boolean, required: true },
        },
    }
</script>
